'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Smile(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#FFF' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size + 1,
      viewBox: '0 0 15 16',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(-22.000000, -17.000000) translate(22.000000, 17.000000)',
        fill: color,
        stroke: 'none',
        strokeWidth: 1,
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', { d: 'M7.494 16C3.424 16.06.074 12.545 0 8.137 0 6.958.884 6 1.974 6c1.09 0 1.974.957 1.974 2.138 0 2.124 1.59 3.846 3.552 3.846s3.552-1.722 3.552-3.846c0-1.18.884-2.138 1.974-2.138C14.116 6 15 6.957 15 8.138c-.073 4.408-3.424 7.922-7.494 7.861M13.003 4a2.018 2.018 0 0 1-1.418-.59A1.983 1.983 0 0 1 11 1.996a2.001 2.001 0 0 1 4 0c0 .534-.211 1.043-.585 1.412-.38.377-.885.588-1.412.591m-11 0a2.018 2.018 0 0 1-1.418-.591A1.985 1.985 0 0 1 0 1.996C0 1.463.211.953.585.584a2.006 2.006 0 0 1 2.83 0C3.789.953 4 1.463 4 1.996c0 .534-.211 1.044-.585 1.413-.38.377-.885.588-1.412.591' })
    )
  );
}

Smile.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = Smile;